import fetch from '../utils/fetch';
import { cmxUrl } from '../endpoints';

function BundleService() {
    
    const getBundle = async( projectName, locales, keys, withoutFallbacks, doNotExport ) => {
        locales = [].concat( locales ).filter( lc => typeof lc === 'string' ).sort();
        keys = [].concat( keys ).filter( k => typeof k === 'string' ).sort();

        const reqBody = {
            locales,
            keys
        };
        let query = `/bundle/${ projectName }`;
        if ( withoutFallbacks !== undefined ) {
            query = `${ query }?withoutFallbacks=${ withoutFallbacks }`;
        }
        if ( doNotExport !== undefined ) {
            query = `${ query }&doNotExport=${ doNotExport }`;
        }

        return new Promise( ( resolve, reject ) => {
        fetch( `${ cmxUrl }${ query }`, {
            method: 'POST',
            body: JSON.stringify( reqBody )
        } ).then( ( res ) => {
            if ( res.ok ) {
                res.json().then( ( data ) => {

                    resolve( data );
                } );
            } else {
                res.json().then( ( data ) => {
                    reject( data.message );
                } );
            }
        } )
        .catch ( ( err ) => {
            reject( err.message );
        } );
    } );

    };

    return {
        getBundle
    };
}

export default new BundleService();
